import {
  ModalDialogBody,
  ModalDialogHeader,
  ModalDialogRoot,
  Text,
} from "@zapier/design-system";

import DeleteModalContent from "./DeleteModalContent";

type Props = {
  onClosed: () => void;
};

export function DeleteModal({ onClosed }: Props) {
  const header = "Delete Canvas";

  return (
    <ModalDialogRoot isOpen={true} onOpenChange={onClosed} aria-label={header}>
      <ModalDialogHeader>
        <Text type="SectionHeader" margin="0 0 23px 0">
          {header}
        </Text>
      </ModalDialogHeader>
      <ModalDialogBody>
        <DeleteModalContent onClosed={onClosed} />
      </ModalDialogBody>
    </ModalDialogRoot>
  );
}
